import { FormattedMessage } from 'react-intl'

const LoadError = (props) => (
  <div className="text-danger text-center" style={{ marginTop: 80, marginBottom: 500 }}>
    <FormattedMessage {...props} />
  </div>
)

export default LoadError
